import { Component } from 'opus-angular-seed-core';

@Component({
    bindings: {
        course: '=',
        occurrence: '=',
        canManageOccurrences: '=',
        context: '=',
        sites: '=',
        courseVersions: '=',
        directManagers: '='
    },
    template: `
    <div class="well color02 ng-scope">
        <div class="heading01">
            <h2>{{ 'course.List of files' | translate }}</h2>
            <a class="btn add" ng-click="vm.addFiles();">{{ 'course.Add files' | translate }}</a>
        </div>
        <pagination-tools list="vm.list"></pagination-tools>
        <list-factory-empty list="vm.list" ng-if="!vm.list.items.length" show-add-message="true"></list-factory-empty>
        <table class="data01" datatable dt-options="vm.DATATABLES" ng-if="vm.list.items.length">
            <thead>
                <tr>
                    <th>{{ 'filter.Name' | translate}}</th>
                    <th>{{ 'filter.Date added' | translate}}</th>
                    <th>{{ 'filter.Added by' | translate}}</th>
                    <th>{{ 'filter.Connected to users' | translate}}</th>
                    <th>{{ 'filter.Added as certificate to' | translate}}</th>
                    <th>&nbsp;</th>
                </tr>
            </thead>
            <tbody>
                <tr ng-repeat="(index, file) in vm.list.items">
                    <td>
                        <span class="wrap-word">
                            {{ file.filename }}
                        </span>
                    </td>
                    <td>{{ vm.MomentService.formatTimeStamp(file.createdAt) }}</td>
                    <td>{{ file.addedBy.displayName }}</td>
                    <td>{{ vm.getFileConnectedUserNames(file) }}</td>
                    <td>{{ vm.getFileCertificatedUserNames(file) }}</td>
                    <td class="actions">
                        <a ng-click="vm.manageConnections(file)" class="btn add">{{ 'course.Manage user connections' | translate }}</a>
                        <a ng-click="vm.download(file)" class="btn ico-download">{{ 'general.Download' | translate }}</a>
                        <a ng-click="vm.delete(file)" class="btn delete">{{ 'general.Delete' | translate }}</a>
                    </td>
                </tr>
            </tbody>
        </table>
        <pagination list="vm.list"></pagination>
    </div>
    `
})
export default class {
    constructor ($translate, $state, $scope, lodash, $window,
                 OccurrenceService, PrivilegeService, TokenService,
                 ModalService, FilterService, SiteService, MomentService,
                 OccurrenceResource, OCCURRENCE_STATUS_ENUM, OCCURRENCE_LANGUAGE_ENUM,
                 OCCURRENCE_BUDGET_ENUM, OCCURRENCE_ACCESS_PERIOD_TYPE_ENUM, AuthResource, OccurrenceFileResource,
                 ListFactory, DATATABLES) {
        this.$translate = $translate;
        this.$state = $state;
        this.$scope = $scope;
        this.$window = $window;
        this.lodash = lodash;
        this.ListFactory = ListFactory;
        this.OccurrenceService = OccurrenceService;
        this.PrivilegeService = PrivilegeService;
        this.TokenService = TokenService;
        this.ModalService = ModalService;
        this.SiteService = SiteService;
        this.MomentService = MomentService;
        this.FilterService = FilterService;
        this.OccurrenceResource = OccurrenceResource;
        this.AuthResource = AuthResource;
        this.DATATABLES = DATATABLES;
        this.OCCURRENCE_STATUS_ENUM = OCCURRENCE_STATUS_ENUM;
        this.OCCURRENCE_LANGUAGE_ENUM = OCCURRENCE_LANGUAGE_ENUM;
        this.OCCURRENCE_BUDGET_ENUM = OCCURRENCE_BUDGET_ENUM;
        this.OCCURRENCE_ACCESS_PERIOD_TYPE_ENUM = OCCURRENCE_ACCESS_PERIOD_TYPE_ENUM;
        this.OccurrenceFileResourse = OccurrenceFileResource;
    }

    $onInit () {
        this.list = this.ListFactory.createWithPagination(this.OccurrenceFileResourse.query.bind(this.OccurrenceFileResourse));
        this.list.pagination.perPage = 25;
        this.updateList();
    }

    updateList () {
        this.list.fetch({ occurrenceId: this.occurrence.id, expand: 'users.user' });

        this.OccurrenceResource.get({
            id: this.occurrence.id,
            expand: 'courseOccurrenceParticipants,courseVersion,courseOccurrenceLanguages,courseOccurrenceManagers,files.addedBy,files.users.user,sites'
        }).$promise.then(occurrence => {
            this.occurrence = occurrence;
        });
    }

    addFiles () {
        const { occurrence } = this;
        this.ModalService.open({
            size: 'large',
            template: `
                <modals-courses-occurrence-files-add
                    class="wrapper"
                    uib-modal-instance="vm.$uibModalInstance"
                    occurrence="vm.occurrence"
                />`,
            controller ($uibModalInstance) {
                this.occurrence = occurrence;
                this.$uibModalInstance = $uibModalInstance;
            }
        }).then(() => this.updateList());
    }

    manageConnections (file) {
        const { occurrence } = this;
        this.ModalService.open({
            size: 'large',
            template: `
                <modals-courses-occurrence-files-certificate
                    class="wrapper"
                    uib-modal-instance="vm.$uibModalInstance"
                    occurrence="vm.occurrence"
                    file="vm.file"
                />`,
            controller ($uibModalInstance) {
                this.occurrence = occurrence;
                this.file = file;
                this.$uibModalInstance = $uibModalInstance;
            }
        }).then(() => this.updateList());
    }

    delete (file) {
        const confirmMessage = this.$translate.instant('course.Are you sure you wish to delete the file?');

        this.ModalService.confirm(confirmMessage, 'medium').then(() => {
            this.occurrence.files = this.lodash.filter(this.occurrence.files, occurFile => occurFile.id !== file.id);
            this.beforeSave();

            this.OccurrenceResource.update({
                id: this.occurrence.id,
                expand: 'courseOccurrenceParticipants,courseVersion,courseOccurrenceLanguages,courseOccurrenceManagers,files.addedBy,files.users.user,sites'
            }, this.occurrence).$promise.then((occurrence) => {
                this.occurrence = occurrence;
                this.updateList();
            });
        });
    }

    download (file) {
        this.AuthResource
            .requestTacToken().$promise
            .then(({ token }) => {
                const url = `${SEED_CORE.ENV.API_URL}course/occurrence/export-file?tacToken=${token}&fileId=${file.id}`;
                this.$window.open(url);
            });
    }

    beforeSave () {
        this.occurrence.directManagerIds = this.occurrence.courseOccurrenceManagers.map(val => val.userId);
        if (this.occurrence.displayUntil && !this.isDateValid(this.occurrence.displayUntil)) {
            this.occurrence.displayUntil = this.MomentService.formatTimeStamp(this.occurrence.displayUntil, 'YYYY-MM-DD HH:mm:ss', true);
        }
        if (this.occurrence.publishDate && !this.isDateValid(this.occurrence.publishDate)) {
            this.occurrence.publishDate = this.MomentService.formatTimeStamp(this.occurrence.publishDate, 'YYYY-MM-DD HH:mm:ss', true);
        }
    }

    /**
     * Checks whether date is in the correct format of YYY-MM-DD HH:mm:ss
     *
     * @param {string} date
     */
    isDateValid (date) {
        const regex = /[0-9]{4}-(0[1-9]|1[0-2])-(0[1-9]|[1-2][0-9]|3[0-1]) (2[0-3]|[01][0-9]):[0-5][0-9]:[0-5][0-9]/;
        return String(date).match(regex);
    }

    next () {
        let state = 'authorized.courses.courses.edit.occurrence.add.schedule';
        if (this.context === 'edit') {
            state = 'authorized.courses.courses.edit.occurrence.edit.schedule';
        }
        this.$state.go(state, {
            id: this.$state.params.id,
            occurrenceId: this.occurrence.id
        });
    }

    getFileCertificatedUserNames (file) {
        return this.lodash.map(this.lodash.filter(file.users, (user) => {
            return user.isCertificate;
        }), item => item.user ? item.user.displayName : '').join(', ');
    }

    getFileConnectedUserNames (file) {
        return this.lodash.map(this.lodash.filter(file.users, (user) => {
            return user.isConnection;
        }), item => item.user ? item.user.displayName : '').join(', ');
    }
}



// WEBPACK FOOTER //
// ./src/app/components/courses/courses/edit/occurrence/steps/files/index.js